// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Djli","col":"styles_col__3r_vt","fulfillmentStatus":"styles_fulfillmentStatus__22Xxo","emailCol":"styles_emailCol__3V6_p"};